import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl';
import styled from 'styled-components';
import { device } from "./device";

import H3 from './styledComponents/H3';
import H4 from './styledComponents/H4';
import H5 from './styledComponents/H5';
import SubTitle from './styledComponents/SubTitle';
import Paragraph from './styledComponents/Paragraph';
import Base from './styledComponents/Base';
import RuleDescription from './styledComponents/RuleDescription';
import UlList from './styledComponents/UlList';
import ChapterSpace from './styledComponents/ChapterSpace';

import { Container,Cell,Grid,AnchorBlock,ChapterHeader,ParentAnchor } from './blockComponents'
import { PlainImage } from './imageComponents'
import { ImageMultilang } from './utility/imageMultilang';

const TypographyItemImg = styled.div`
    max-width: 859px;
    width: 100%;
`;
const PartnerLogo2 = styled.div`
    margin-right: 64px;
    margin-top: 32px;
    max-width: 186px;
    width: 100%;

    font-size: 0;
    @media ${device.lg} {
        margin-right: 78px;
    }
`;
const PartnerLogo3 = styled.div`
    margin-top: 32px;
    max-width: 150px;
    width: 100%;

    font-size: 0;
`;
const PartnerLogos = styled.div`
    display: flex;
    flex-wrap: wrap;
`;
const TypographyDont = styled.div`
    margin-top: 32px;
    @media ${device.md} {
        margin-top: 0;
    }
`;

function Typography({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
        
    return (
        <ParentAnchor
            key='typographySection'
            blockId="typography-section"
            blockName='typographySection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'MainMenu_3' })} downloadLink="https://fonts.google.com/specimen/Roboto"></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <AnchorBlock
                            key='typographyBlock'
                            blockName='typographyBlock'
                            blockId='typography'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'typography_title' })}</H3>
                            <SubTitle >{intl.formatMessage({ id: 'typography_subtitle' })}</SubTitle>
                            <Base space="TopDown">{intl.formatMessage({ id: 'typography_1_1' })}</Base>
                            <RuleDescription />
                            <ImageMultilang 
                                intl={intl} 
                                last="xs"
                                imageRu='typography/txt-1-ru@2x.jpg'
                                imageUk='typography/txt-1-uk@2x.jpg'
                                imageEn='typography/txt-1-en@2x.jpg'/>
                            <Base space="TopDown">{intl.formatMessage({ id: 'typography_1_3' })}</Base>
                            <RuleDescription rule="do" />
                            <ImageMultilang 
                                intl={intl} 
                                last="xs"
                                imageRu='typography/txt-2-ru@2x.jpg'
                                imageUk='typography/txt-2-uk@2x.jpg'
                                imageEn='typography/txt-2-en2@2x.jpg'/>
                            <H4 space="TopDown">{intl.formatMessage({ id: 'typography_2_1' })}</H4>
                            <SubTitle>{intl.formatMessage({ id: 'typography_2_2' })}</SubTitle>

                            <H5 space="TopDown">{intl.formatMessage({ id: 'typography_2_3' })}</H5>
                            <RuleDescription rule="do">{intl.formatMessage({ id: 'typography_2_4' })}</RuleDescription>
                            <TypographyItemImg>
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='typography/pair-1-ru@2x.png'
                                    imageUk='typography/pair-1-uk2@2x.png' 
                                    imageEn='typography/pair-1-en1@2x.png'/>
                            </TypographyItemImg>

                            <H5 space="TopDown">{intl.formatMessage({ id: 'typography_2_5' })}</H5>
                            <RuleDescription rule="do">{intl.formatMessage({ id: 'typography_2_6' })}</RuleDescription>
                            <TypographyItemImg>
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='typography/pair-2-ru2@2x.png'
                                    imageUk='typography/pair-2-uk2@2x.png'
                                    imageEn='typography/pair-2-en2@2x.png'/>
                            </TypographyItemImg>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'typography_3_1' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'typography_3_2' })}</Paragraph>
                            <PartnerLogos>
                                <PartnerLogo2><PlainImage src="typography/partner-mark@2x.png" last="xs" alt="" /></PartnerLogo2>
                                <PartnerLogo3><PlainImage src="typography/protected-by-ajax@2x.png" last="xs" alt="" /></PartnerLogo3>
                            </PartnerLogos>

                            <H5 space="TopDown">{intl.formatMessage({ id: 'typography_3_3' })}</H5>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'typography_3_4' })}</Paragraph>
                            <Grid>
                                <Cell col={6}>
                                    <RuleDescription />
                                    <PlainImage src="typography/caps-1@2x.png" last="xs" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <RuleDescription rule="do" />
                                    <PlainImage src="typography/caps-2@2x.png" last="xs" alt="" />
                                </Cell>
                            </Grid>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'typography_3_5' })}</H4>
                            <RuleDescription>{intl.formatMessage({ id: 'typography_3_6' })}</RuleDescription>
                            <Grid>
                                <Cell col={6} colMd={3}>
                                    <div><PlainImage src="typography/dont-1@2x.png" last="xs" alt="" /></div>
                                </Cell>
                                <Cell col={6} colMd={3}>
                                    <div><PlainImage src="typography/dont-2@2x.png" last="xs" alt="" /></div>
                                </Cell>
                                <Cell col={6} colMd={3}>
                                    <TypographyDont><PlainImage src="typography/dont-3@2x.png" last="xs" alt="" /></TypographyDont>
                                </Cell>
                                <Cell col={6} colMd={3}>
                                    <TypographyDont><PlainImage src="typography/dont-4@2x.png" last="xs" alt="" /></TypographyDont>
                                </Cell>
                            </Grid>

                            <H3 space="Top">{intl.formatMessage({ id: 'typography_4' })}</H3>
                            <H4 space="TopDown">{intl.formatMessage({ id: 'typography_4_1' })}</H4>
                            <UlList>
                                <li>{intl.formatMessage({ id: 'typography_4_1_1' })}</li>
                                <li>{intl.formatMessage({ id: 'typography_4_1_2' })}</li>
                                <li>{intl.formatMessage({ id: 'typography_4_1_3' })}</li>
                                <li>{intl.formatMessage({ id: 'typography_4_1_4' })}</li>
                            </UlList>
                            <H4 space="TopDown">{intl.formatMessage({ id: 'typography_5_1' })}</H4>
                            <UlList>
                                <li>{intl.formatMessage({ id: 'typography_5_1_1' })}</li>
                                <li>{intl.formatMessage({ id: 'typography_5_1_2' })}</li>
                                <li>{intl.formatMessage({ id: 'typography_5_1_3' })}</li>
                                <li>{intl.formatMessage({ id: 'typography_5_1_4' })}</li>
                            </UlList>
                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor>
        
    )
}

export default injectIntl(Typography)